module.exports = __webpack_public_path__ + "img/green_dollar.ccaf5b8b.svg";